import React from 'react'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdAssignmentTurnedIn from 'react-icons/lib/md/assignment-turned-in'
import MdAssignment from 'react-icons/lib/md/assignment'
import styles from './styles.css'
import FileBinary from 'react-icons/lib/go/file-binary'
import MdAccessTime from 'react-icons/lib/md/access-time'

export default function(documentStatus) {
  //console.log("documentStatus", documentStatus);
  if (documentStatus.status === 'ready') {
      return (
        <div>
          <Tooltip content={tootipContent(documentStatus)}>
            {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
  } else if (documentStatus.status === 'feaFlow') {
    return (
      <div>
        <Tooltip content={tootipContent(documentStatus)}>
          {<FileBinary className={styles.icon1} size={20} />}
        </Tooltip>
      </div>
    )
  } else if (documentStatus.status === 'bioFlow') {
    return (
      <div>
        <Tooltip content={tootipContent(documentStatus)}>
          {<MdAccessTime className={styles.icon1} size={20} />}
        </Tooltip>
      </div>
    )
  } else if (documentStatus.status === 'sent') {
    return (
      <div>
        <Tooltip content={tootipContent(documentStatus)}>
          {<MdAccessTime className={styles.icon2} size={20} />}
        </Tooltip>
      </div>
    )
  } else if (documentStatus.status === 'personal') {
    return (
      <div>
        <Tooltip content={tootipContent(documentStatus)}>
          {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
        </Tooltip>
      </div>
    )
  } else {
    //console.log("Icono por defecto:", documentStatus.status)
    return (
      <div>
        <Tooltip content={tootipContent(documentStatus)}>
          {<MdAssignment className={styles.icon3} size={20} />}
        </Tooltip>
      </div>
    )
  }
  
}


function tootipContent(documentStatus){
  //console.log("====> renderTooltipDocument ", documentStatus);
  if (documentStatus.status === 'ready') {
    return <p>Documento firmado</p>
  } else if (documentStatus.status === 'feaFlow') {
    return <p>Esperando firmas electrónicas avanzadas</p>
  } else if (documentStatus.status === 'bioFlow') {
    return <p>Esperando autorizaciones biométricas</p>
  } else if (documentStatus.status === 'sent') {
    return <p>Esperando firmas del documento</p>
  } else if (documentStatus.status === 'personal') {
    return <p>Documento personal</p>
  } else {            //pending
    //console.log("Status no encontrado:", documentStatus.status)
    return <p>Documento no enviado para firmar</p>
  }  
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Common/docIcon.js